<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}

export default {
  mixins: [navigation],
  name: "app",
  deactivated() {
    this.time = 75;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.time > 0 && !this.sent) {
          this.time--;
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage(this.next);
          }
        }
      }, 1000);
    }
  },
  data() {
    return {
      last: "P_45",
      next: "P_47",
      topic:
        "Estás en: Taller ¿Qué es crédito? / ¿Qué aprendí en esta lección?",
      reactivos: [
        {
          descripcion:
            "No se desembolsa una gran cantidad. ",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion:
            "El servicio o bien se disfruta de inmediato. ",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: "Se crea historial crediticio.",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: "Puedo elegir el monto.",
          correcta: false,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: "El monto se suma a mis ahorros. ",
          correcta: false,
          respuesta: false,
          resultado: 0
        }
      ],
      respuestas: [
        "SEGURO DE INVALIDEZ",
        "SEGURO DE VIDA",
        "SEGURO DE DESEMPLEO",
        "SEGURO CONTENIDOS Y DAÑOS"
      ],
      selected: [],
      resultado: 0,
      response: "none",
      sent: false,
      feedback: false,
      dialog: false,
      time: 60,
      timer: null,
      interaction: {
        id: "TCC.L1.9.1",
        questionText: "Afirmaciones verdaderas",
        learnerResponse: "",
        correctAnswer: "",
        wasCorrect: true
      }
    };
  },
  computed: {
    testComplete() {
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == "none") {
          this.completo = "none";
        }
      });
      this.completo = "true";
    },
    responseIsNone() {
      return {
        "btn-primary": this.response != "none",
        "btn-secondary": this.response == "none"
      };
    }
  },
  beforeMount: function() {
    shuffle(this.respuestas);
  },
  beforeUpdate: function() {
    var respuestas = this.respuestas;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          respuestas.push(reactivo.respuesta.shift());
        } else {
          respuestas.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  methods: {
    grade: function() {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta == reactivo.respuesta) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit("send_result", this.resultado);
      eventBus.$emit("suspend_data", this.reactivos);
      this.response = this.resultado;
    }
  }
};
</script>


<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(sm12, md11, lg9, xl7, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat).centerCard
            breadcrumb(:back='last') {{topic}} 
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 1 DE 5
            img.pt-3(style="width:61px; heigth:67px;", src="@/assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg.text-center Existen ventajas al contratar un crédito.  
            v-card-text.parrafoDestacadoB.text-center
              | De la siguiente lista, selecciona tres ventajas reales de contratar un crédito.
            v-card.questionCard(justify-center, flat)
              v-layout.ml-5.my-0.py-0(v-for='(reactivo, index) in reactivos', :key='index')
                    v-flex(xs1, offset-xs1, align-center, align-content-center)
                      v-icon(size='15px', color='green', v-if='sent && (reactivo.resultado === 1)') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (reactivo.resultado === 0)') fas fa-times
                    v-flex(xs1)
                      v-checkbox(style="margin-top: -7px;", hide-details, v-model='reactivo.respuesta')
                    v-flex.parrafoDestacadoB.text-xs-left.py-2(xs10, align-content-center)
                      | {{reactivo.descripcion}}
          v-layout(row, justify-center)
            v-flex
              div(v-if='!sent')
                v-btn.btn(color='secondary ', v-bind:class='responseIsNone ',  @click='sendResult() ')
                  | Enviar
              div(v-if='sent')
                v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                  | Retroalimentación
                v-dialog(v-model='dialog ', persistent, max-width='930px ', content-class="dialog_over")
                  v-layout(row, justify-center)
                    v-flex(text-xs-center)
                      v-card
                        .pt-1.pr-2(v-if='sent && (response==1) ')
                          v-layout(row, justify-center)
                            v-flex(text-xs-center)
                              img.dialog_img(src='@/assets/ManoOk.png')
                          v-spacer.my-1.py-4
                          v-card-text.headline
                            | Elegiste correctamente!
                          v-card.questionCard(flat)
                            v-card-text.dialog_text
                              p.text-sm-left.px-5.my-0
                                | Además de las ventajas reales que seleccionaste, existen otras como no pagar intereses si liquidas anticipadamente el crédito.
                        .pt-1.pr-2(v-if='sent && (response!=1) ')
                          v-layout(row, justify-center)
                            v-flex(text-xs-center)
                              img.dialog_img(src='@/assets/ManoStop.png')
                          v-spacer.my-1.py-4
                          v-card-text.headline
                            | Hay una mejor respuesta...
                          v-card.questionCard(flat)
                            v-card-text.dialog_text
                              p.text-sm-left.px-5.my-0
                                | Te acercaste, pero en realidad las tres ventajas de contratar un crédito son: 
                                ul 
                                  li No se desembolsa una gran cantidad. 
                                  li El servicio o bien se disfruta de inmediato. 
                                  li Se crea historial crediticio. 
                                | Existen otras ventajas de contratar un crédito, como no pagar intereses si se hacen los pagos en tiempo. 
                        v-btn.btn.dialog_btn.my-4(color='accent ', @click.prevent="nextPage(next)")
                          | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>
